import React from "react";

import { MarkSvg } from "../styles";
import { MarkProps } from "../types";

/** Stacked ledger lines beside a rising trace. */
const LedgerMark = ({ size, ...rest }: MarkProps) => (
  <MarkSvg width={size} height={size} viewBox="0 0 40 40" fill="none" {...rest}>
    <rect x="5" y="8" width="25" height="25" rx="6" fill="#27B6E4" opacity="0.22" />
    <rect x="10" y="5" width="25" height="30" rx="7" fill="url(#bo-logo-ledger-bg)" />
    <path d="M16 14H29" stroke="#EDEEFA" strokeWidth="2.2" strokeLinecap="round" />
    <path d="M16 20H25" stroke="#EDEEFA" strokeWidth="2.2" strokeLinecap="round" opacity="0.78" />
    <path d="M16 26H22" stroke="#EDEEFA" strokeWidth="2.2" strokeLinecap="round" opacity="0.58" />
    <path
      d="M23.5 27L27.2 23.2L30.6 26.2L34 21.1"
      stroke="#56C456"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="34" cy="21" r="2.2" fill="#FEB23A" />
    <defs>
      <linearGradient
        id="bo-logo-ledger-bg"
        x1="13"
        y1="7"
        x2="35"
        y2="34"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7748FC" />
        <stop offset="0.55" stopColor="#633DD1" />
        <stop offset="1" stopColor="#182524" />
      </linearGradient>
    </defs>
  </MarkSvg>
);

export default LedgerMark;
